
export default {
    'HotTopics': '/api/CustomerService/Knowledge/HotTopics?serviceType=1&', // 1111


    'Categories': '/api/CustomerService/Knowledge/Categories?serviceType=1&',///111
    'Detail': '/api/CustomerService/Knowledge/', // 1111




    'QuestionTypes': '/api/CustomerService/Case/QuestionTypes?',// 1111

    'SearchTerm': '/api/CustomerService/Knowledge?serviceType=1&',
    // 


    'PostCase': '/api/CustomerService/Case?',
    'Case': '/api/CustomerService/Case?',
    'PresignedUrl': '/api/CustomerService/Case/PresignedUrl?serviceCode=1&',


    'GloqoSearch': '/api/CustomerService/GloqoSearch?'
}